import React, { useState } from 'react';
import css from './DocumentAndPaywallComponent.module.css';
import OutsideClickHandler from '../OutsideClickHandler/OutsideClickHandler';
import IconCollection from '../IconCollection/IconCollection';

import { FOLDER_DOCUMENT_PAGE_SIZE, GROUP_PAYMENT_PAGE_SIZE } from '../../containers/MyGroupCommunityPage/MyGroupCommunityPage.duck';
import { FormattedMessage } from '../../util/reactIntl';
import { getCommunityUserRole } from '../../util/data';
import { GROUP_PAYMENT_PAGE_PAYMENT_HISTORY, GROUP_PAYMENT_STATUS_ACTIVE, GROUP_PAYMENT_STATUS_CLOSED, GROUP_PAYMENT_STATUS_DRAFT, PAYMENT_DASH_CREATE_PAYMENT, PAYMENT_DASH_MAKE_PAYMENT, PAYMENT_DASH_PAYMENT_DASHBOARD, PAYMENT_DASH_VIEW_PAYMENT_HISTORY } from '../../util/types';
import { createResourceLocatorString } from '../../util/routes';

const MANAGE_GROUP_PAYMENT_STATUSES = [
  GROUP_PAYMENT_STATUS_ACTIVE,
  GROUP_PAYMENT_STATUS_CLOSED,
  GROUP_PAYMENT_STATUS_DRAFT,
];

const DocumentAndPaywallComponent = props => {
  const {
    onClickDocumentDropdown,
    isDropdownDocument = false,
    onToggelAddDocument,
    onToggelAddFolder,
    params,
    allGroupFolders,
    fetchFolderRequest,
    fetchFolderError,
    onToggelFolderDocument,
    spaceDetail,
    totalDocumentCount,
    onFetchGroupDocumentFolder,
    onToggelSearchInGroup,
    hideMobileSearch = false,
    userModeratorsGroups,
    checkMakeGroupPayments,
    setPaymentDashTab,
    onFetchGroupPayment,
    onFetchAdminModerator,
    history,
    routeConfiguration,
    adminModerator,
    allGroupPayments,
    toastifyFn,
    currentUser,
    isOpenElephantModal,
    onSetElephantVerificationModal
  } = props;
const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  const allGroupPaymentsForThisSpace = Array.isArray(allGroupPayments?.data) && spaceDetail?.id ? allGroupPayments.data.filter(payment => payment?.groupId == spaceDetail?.id) : [];
  const adminModeratorForThisSpace = adminModerator?.groupId && spaceDetail?.id && adminModerator.groupId == spaceDetail.id;
  const isAuthorStripeAccountLinked = adminModerator?.isAuthorStripeAccountLinked

  const [isPaymentDashOpen, setPaymentDashOpen] = useState(false);

  const { is_private, is_member, policies } = spaceDetail ?? {};
  const { can_manage_space, can_view_space } = policies ?? {};

  const userRoleInGroup = getCommunityUserRole(userModeratorsGroups, spaceDetail?.id);
  const userHaveDocumnetViewPermissions = ["admin", "moderator"].includes(userRoleInGroup) || can_view_space;
  const userHaveDocumnetUpadtePermissions = ["admin", "moderator"].includes(userRoleInGroup);

  //If a group is private, the [Documents] dropdown will only be visible to users that have joined the group.
  // if (is_private && !is_member) return null

  const documnetData = { id: 'addDocument', name: 'Add a Document' };
  const addFolderData = { id: 'addFolder', name: 'Add a Folder' };

  const documentDropdownData = [];

  if (
    userHaveDocumnetUpadtePermissions &&
    totalDocumentCount < process.env.REACT_APP_DOCUMENTS_LENGTH
  ) { 
    documentDropdownData.push(documnetData);
  }

  if (
    userHaveDocumnetUpadtePermissions &&
    Array.isArray(allGroupFolders) &&
    allGroupFolders.length < process.env.REACT_APP_FOLDER_LENGTH
  ) {
    documentDropdownData.push(addFolderData);
  } 
  const { id } = params || {};

  // payment options
  const paymentViews = [];
  if (["admin"].includes(userRoleInGroup)) {
    paymentViews.push({ id: PAYMENT_DASH_CREATE_PAYMENT, name: '+ Create Payment' });
    paymentViews.push({ id: PAYMENT_DASH_PAYMENT_DASHBOARD, name: 'Payment Dashboard' });
  }

  if (["moderator"].includes(userRoleInGroup)) {
    adminModeratorForThisSpace && paymentViews.push({ id: PAYMENT_DASH_CREATE_PAYMENT, name: '+ Create Payment' });
    paymentViews.push({ id: PAYMENT_DASH_PAYMENT_DASHBOARD, name: 'Payment Dashboard' });
  }

  if (checkMakeGroupPayments && allGroupPaymentsForThisSpace.length) {
    paymentViews.push({ id: PAYMENT_DASH_MAKE_PAYMENT, name: "+ Make Payment" });
    paymentViews.push({ id: PAYMENT_DASH_VIEW_PAYMENT_HISTORY, name: "View Payment History" });
  };

  // Sort payment options alphabetically by name
  paymentViews.sort((a, b) => {
    const nameA = (a.name || '').toLowerCase();
    const nameB = (b.name || '').toLowerCase();
    return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' });
  });

  const handleDocumentDropdown = value => {
    if (value.id === 'addDocument') {
      onToggelAddDocument(true);
      onClickDocumentDropdown(false);
    } else if (value.id === 'addFolder') {
      onToggelAddFolder({ groupId: id });
      onClickDocumentDropdown(false);
    } else {
      const { groupId, folderId } = value;
      //fetch all folder documents
      onFetchGroupDocumentFolder({
        payload: {
          groupId,
          folderId,
          isActive: true,
          isDelete: false,
        },
        pageParams: {
          page: 1,
          perPage: FOLDER_DOCUMENT_PAGE_SIZE,
        },
      });
      onToggelFolderDocument(value);
      onClickDocumentDropdown(false);
    }
  };

  const showgropFolders = Array.isArray(allGroupFolders)
    ? allGroupFolders
      .filter(st =>
        userHaveDocumnetUpadtePermissions ? st : st.documentCount && st.documentCount > 0
      )
      .sort((a, b) => {
        const nameA = (a.folderName || '').toLowerCase();
        const nameB = (b.folderName || '').toLowerCase();
        return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' });
      })
    : [];

  return (
    <div className={css.feedNav2}>
      <div className={css.selectWrapper}>
        {(userHaveDocumnetViewPermissions && showgropFolders.length) ||
          userHaveDocumnetUpadtePermissions ? (
          <div className={css.documentWrapper}>
            <OutsideClickHandler onOutsideClick={() => isDropdownDocument && onClickDocumentDropdown(false)}>
              <div onClick={() => onClickDocumentDropdown(!isDropdownDocument)}>
                Documents <IconCollection name="arrowDown" />
              </div>
              {isDropdownDocument ? (
                <div className={css.dropdownMenu}>
                  <ul>
                    {documentDropdownData?.map(option => (
                      <li key={option.id} onClick={() => handleDocumentDropdown(option)}>
                        + {option.name}
                      </li>
                    ))}
                    {showgropFolders.map(option => (
                      <li
                        key={option.folderId}
                        onClick={() => handleDocumentDropdown(option)}
                        style={{ paddingLeft: '20px' }}
                      >
                        {option.folderName}
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}
            </OutsideClickHandler>
          </div>
        ) : null}

        {(paymentViews.length) ? (
          <div className={css.documentWrapper}>
            <OutsideClickHandler onOutsideClick={() => isPaymentDashOpen && setPaymentDashOpen(false)}>
              <div onClick={() => setPaymentDashOpen(!isPaymentDashOpen)}>
                Payments <IconCollection name="arrowDown" />
              </div>
              {isPaymentDashOpen ? (
                <div className={css.dropdownMenuPayment}>
                  <ul>
                    {paymentViews.map(option => (
                      <li
                        key={option.id}
                        onClick={() => {
                          setPaymentDashOpen(false);
                          if (!spaceDetail?.id) return;
                          const isMakePayment = option.id == PAYMENT_DASH_MAKE_PAYMENT;

                          if (isMakePayment && isOpenElephantModal) {
                            onSetElephantVerificationModal(true);
                            return;
                          }

                          if (option.id == PAYMENT_DASH_CREATE_PAYMENT && !adminModeratorForThisSpace) {
                            toastifyFn('info', 'Admin not found for this space');
                            return;
                          };

                          if (option.id == PAYMENT_DASH_CREATE_PAYMENT && !isAuthorStripeAccountLinked) {
                            toastifyFn('info', 'Payout details for the admin are currently unavailable.');
                            return;
                          };

                          // Handle special case early and exit
                          if (option.id == PAYMENT_DASH_VIEW_PAYMENT_HISTORY) {
                            console.log('PAYMENT_DASH_VIEW_PAYMENT_HISTORY triggered');
                            return history.push(
                              createResourceLocatorString(
                                'GroupPaymentHistoryPage',
                                routeConfiguration,
                                { tab: GROUP_PAYMENT_PAGE_PAYMENT_HISTORY },
                              )
                            );
                          }
                          setPaymentDashTab(option.id);
                          const shouldFetchPayments = [PAYMENT_DASH_MAKE_PAYMENT, PAYMENT_DASH_PAYMENT_DASHBOARD].includes(option.id);
                          if (shouldFetchPayments) {

                            // fetch admin of that group
                            isMakePayment ? onFetchAdminModerator({
                              payload: {
                                groupId: spaceDetail.id + "",
                                status: 'active',
                                role: 'admin',
                              },
                            }) : null;

                            onFetchGroupPayment({
                              payload: {
                                groupId: spaceDetail.id + "",
                                ...(isMakePayment
                                  ? { status: GROUP_PAYMENT_STATUS_ACTIVE }
                                  : { status: { $in: MANAGE_GROUP_PAYMENT_STATUSES } }),
                              },
                              pageParams: {
                                page: 1,
                                perPage: GROUP_PAYMENT_PAGE_SIZE,
                              }
                            }, { userId: currentUser?.id?.uuid });
                          }
                        }}
                      >
                        {option.name}
                      </li>

                    ))}
                  </ul>
                </div>
              ) : null}
            </OutsideClickHandler>
          </div>
        ) : null}
      </div>

      {isMobile && !hideMobileSearch ? (
        <div className={css.searchBar} onClick={() => onToggelSearchInGroup(true)}>
          <FormattedMessage id="SearchIngroup.searchBar" />
        </div>
      ) : null}
    </div>
  );
};

export default DocumentAndPaywallComponent;
